import { getCookie } from './getCookie';
export function getUtk() {
  const hstc = getCookie('__hstc');
  if (!hstc) return '';
  const utk = hstc.split('.')[1];
  return utk || '';
}